import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PagesComponent } from './pages/pages.component';
import { AuthGuard } from './core/guards/auth.guard';
import { PermissionGuard } from './core/guards/permission.guard';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  {
    path: '',
    component: PagesComponent, children: [
      { path: '', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
      { path: 'home', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule), canActivate: [AuthGuard] },
      { path: 'users', loadChildren: () => import('./pages/settings/users/users.module').then(m => m.UsersModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'rolePerm', loadChildren: () => import('./pages/settings/role-perm/role-perm.module').then(m => m.RolePermModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'invoice', loadChildren: () => import('./pages/documents/invoice/invoice.module').then(m => m.InvoiceModule), canActivate: [AuthGuard, PermissionGuard] },
      { path: 'logsDocuments', loadChildren: () => import('./pages/logs/logs-documents/logs-documents.module').then(m => m.LogsDocumentsModule)},
      { path: 'logsViewer', loadChildren: () => import('./pages/logs/viewer/viewer.module').then(m => m.ViewerModule)},
    ]
  },
  { path: 'login', loadChildren: () => import('./pages/login-app/login-app.module').then(m => m.LoginAppModule) },
  { path: '**', loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule) },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
